// extracted by mini-css-extract-plugin
export default {"container":"ModalBalance_container__jRMjf","title":"ModalBalance_title__AFJW6","description":"ModalBalance_description__RDmzT","button":"ModalBalance_button__VW4qb"};